import type { ReactElement } from 'react'

import SeriesQ from '@/queries/SeriesQ'
import SessionQ from '@/queries/SessionQ'
import type { Query } from '@/client/query'

import HostAvatars from './HostAvatars'
import { getSeriesHostAvatarDetails, getSessionHostAvatarDetails } from './helpers'

export default function HostAvatarsFromQuery({
  sessionOrSeries,
  isSession,
  isTooltip,
}: {
  sessionOrSeries: Query
  isSession: boolean
  isTooltip: boolean
}): ReactElement {
  const hosts = isSession
    ? getSessionHostAvatarDetails(sessionOrSeries)
    : getSeriesHostAvatarDetails(sessionOrSeries)
  const numHosts =
    (isSession
      ? sessionOrSeries(SessionQ.countAllHosts({ approved: true }))
      : sessionOrSeries(SeriesQ.countAllHosts({ approved: true }))) ?? 1

  return (
    <HostAvatars hosts={hosts} numHosts={numHosts} isSession={isSession} isTooltip={isTooltip} />
  )
}
